import React,{useEffect,useState} from 'react';


import Select from "react-select";

import ReactDatetime from "react-datetime";
import moment from "moment";
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledTooltip
} from "reactstrap";
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { withRouter } from "react-router-dom";
// import {EMAIL_TEMPLATE,DAYWISE_EMAIL_REPORTS,CHANNEL_CLIENT_CHNLTYPE} from "../../constants.js";
import {EMAIL_TEMPLATE,DAYWISE_EMAIL_REPORTS,CHANNEL_CLIENT_CHNLTYPE} from "../../constants"
import axios from "axios"; 
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";


// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
import Tst, {
  chartExample1
} from "./charts";
// import moment from 'moment';



var initialvalues = {

  fromdate:"",
  todate:"",
  templateid: "",
  sender:""
}

let userObj = localStorage.getItem("user");
let user = JSON.parse(userObj);
let templates = [{ value:"email", label: "Email" },{ value:"sms", label: "Sms" },{ value:"whatsapp", label: "Whatsapp" },{ value:"ivr", label: "IVR" },{ value:"rcs", label: "Rcs" }];
let cci = [{ value:"custom1", label: "Custom Code 1" },{ value:"custom2", label: "Custom Code 2" },{ value:"custom3", label: "Custom Code 3" }];
let senderids = [];
const UsageAnalytics = () => {
  let totaldaycnt=0
  let totalweekcnt=0


  const[todaycnt,setTodaycnt]= useState([])
  const[weekcnt,setWeekcnt]= useState([])

  const userObj = localStorage.getItem("menus");
  const  user= JSON.parse(userObj);
  const [bigChartData, setbigChartData] = React.useState("emails");
  const [input,setInput] = useState({name:"",id:""})

  const [searchClone,setSearchClone] = useState('')
  const [clients,setClients] =useState([]);

  const changeBgChartData = (name) => {
    setbigChartData(name);
  };

  let loginUser = localStorage.getItem("user");
  let luser = JSON.parse(loginUser);

  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorhandle,setErrorHandle]= useState()
  const [channel, setChannel] = useState([]);

 
  const [daywiseList,setDaywiseList] = useState([]);
  const[search,setSearch] = useState(initialvalues);
  const[validate,setValidate] = useState({
    message:"",
    notValid:false
  })





  const changeSender=(data)=>{
 
    senderids=[]
   
    const chnl=channel.filter(item=>item.template==data.value)
      
    const senderid = chnl[0]?.senderid?.split(",");
        for(let i=0;i<senderid?.length;i++){
          senderids.push({label:senderid[i],value:senderid[i]})
        }
   
    
    setSearch(prev=>({...prev,templateid:data,sender:""}))
  }

  const submitHandler = async() =>{
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
    const templateid = search?.templateid?.value
    await axios.get(DAYWISE_EMAIL_REPORTS+"?startdatePickup="+fromdate+"&enddatePickup="+todate+"&templateid="+templateid).then((res)=>{
      setDaywiseList(res.data.message)
    }).catch((err)=>console.log("error====>",err))
  
  }

  const generateExcel=async()=>{
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
    const templateid = search?.templateid?.value
    await axios.get(DAYWISE_EMAIL_REPORTS+"?startdatePickup="+fromdate+"&enddatePickup="+todate+"&templateid="+templateid).then((res)=>{
     const body=res.data.message.length>0?res.data.message:"No Records"
      const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(body);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, templateid + fileExtension);
    }).catch((err)=>console.log("error====>",err))
  }

  function createData(sno,date,nsent,ndelivered,nread,ncost,tsent,tdelivered,tread) {
    return {sno,date,nsent,ndelivered,nread,ncost,tsent,tdelivered,tread };
  }

  return (
    <div className='content'>
        <Row>
          <Col md="12">
            <Card className='mb-2'>
              <CardBody>
                <Row>
                  <Col md='2' sm="12">
                  <p className="category">From Date</p>
                  <ReactDatetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date"
                    }}
                    closeOnSelect={true}
                    timeFormat={false}
                    value={search.fromdate}
                    onChange={(val) =>{setSearch({...search,fromdate:val._d});setValidate({
                      message:"",
                      notValid:false
                    } )}}
                  />
                  </Col>
                  <Col md='2' sm="12">
                  <p className="category">To Date</p>
                  <ReactDatetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date"
                    }}
                    closeOnSelect={true}
                    timeFormat={false}
                    value={search.todate}
                    onChange={(val) =>{setSearch({...search,todate:val._d});setValidate({
                      message:"",
                      notValid:false
                    } )}}
                  />
                  </Col>
                  <Col md="3" sm="12">
          <p className="category">Template<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="templateSelect"
            value={search.templateid}
            onChange={(value) =>  changeSender(value)}
            options={templates}
            placeholder="Select"
          />
          {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
        </Col>
        <Col md="3" sm="12">
          <p className="category">CCI<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="templateSelect"
            value={search.templateid}
            onChange={(value) =>  changeSender(value)}
            options={cci}
            placeholder="Select"
          />
          {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
        </Col>
   
                  <Col md='2' sm='6'>
                  <Button 
                    color="primary "
                    className="mt-4 btn btn-icon animation-on-hover"
                    id="tooltipsubmit"
                    type="button"
                    onClick={()=>submitHandler()}
                  >
                     <i className="tim-icons icon-double-right" />
                  </Button>
                  <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltipsubmit"
                >
                  
                  Submit
                </UncontrolledTooltip>

                <Button className="btn-primary btn-simple btn-icon btn-round  btn-icon mt-4 pull-right" 
                    color="primary" 
                    data-placement="top"
                    id="tooltipexcel"
                    type="button"
                    onClick={()=>generateExcel()}
                  >
                    <i className="tim-icons icon-cloud-download-93" />
                  </Button>                  
                <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltipexcel"
                >
                  Excel
                </UncontrolledTooltip>
               
                  </Col>
                  {/* <Col md='2' sm='6' className='pull-right'>
                  
                  </Col>
                  <Col md='2' sm="12" className="mt-4">
                    <MDBInput label="Search" type="text" />
                  
                  </Col> */}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
       
                <div className="chart-area">
                  <Line
                    data={chartExample1[bigChartData]}
                    options={chartExample1.options}
                   
                  />
                </div>

    

    </div>
  )
}
export default UsageAnalytics;
